/*
File Name: index.js
Created Date: 2020-08-28 13:50:28
Author: yeyong
Last modified: 2020-11-26 09:30:36
*/
import request from './request.js'
const api = {
    getDir: payload => {
        return request.get(payload.path, {params: payload})
    },
    index: () => {
        return request.get("/")
    },
    deleteFile: path => {
        return request.delete(path)
    },
    searchFile: payload => {
        return request.get(`/search/${payload.path}`, {params: payload})
    },
    login: payload => {
        return request.post("/login", payload)
    },
    DownloadFile: payload => {
        return request.post(payload.path, payload)
    },
    createDir: payload => {
        return request.post("/create", payload)
    },
    createOrder: payload => {
        return request.post("/create_order", payload)
    }
}

export default api
